// libs
import React, { memo, useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useHistory } from 'react-router';

// helpers
import { transformColorVariants } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ColorSwatches/helpers';
import { trackPDPColorVariantClicked } from 'shared/layouts/DetailsPage/analytics';

// defs
import { IColorOptions } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ColorSwatches/types';
import { IColorOption } from 'shared/components/ColorSwatchesPDP/types';

// styles
import { Container, SelectedColor, ColorSwatches, SecondaryTitle } from './styles';

const TITLE = 'Select Color';
function ColorOptions({
  colorOptions,
  defaultColor,
  currentImage,
  aspectRatio,
  currentUrl,
  isCurrentInStock,
}: IColorOptions) {
  const transformedColorOptions = useMemo(() => {
    return transformColorVariants({
      colorOptions,
      defaultColor,
      currentImage,
      aspectRatio,
      currentUrl,
      isCurrentInStock,
    });
  }, [aspectRatio, colorOptions, currentImage, currentUrl, defaultColor, isCurrentInStock]);

  const history = useHistory();

  // does not render if no color options available
  if (isEmpty(transformedColorOptions) || transformedColorOptions.length < 2) {
    return null;
  }

  const onColorSelection = (item: IColorOption) => {
    if (!item.name) {
      return;
    }
    trackPDPColorVariantClicked(item.name);
    setTimeout(() => {
      history.push(item.actionUrl);
    }, 100);
  };

  return (
    <Container data-test="color-opts">
      <SecondaryTitle>{TITLE}</SecondaryTitle>
      {defaultColor && defaultColor.name && (
        <SelectedColor data-at="color-shade">{defaultColor.name}</SelectedColor>
      )}
      <ColorSwatches colorOptions={transformedColorOptions} onItemClick={onColorSelection} />
    </Container>
  );
}

export default memo(ColorOptions);
